// extracted by mini-css-extract-plugin
export default {"drawers":"styles_drawers__rG3fI","drawers-template":"styles_drawers-template__U089q"};